import { render, staticRenderFns } from "./DiagnosisPlansTable.vue?vue&type=template&id=54eae462&"
import script from "./DiagnosisPlansTable.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports